// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1Ptl4","bigColWidth":"Table_bigColWidth__3hVeS","biggerColWidth":"Table_biggerColWidth__26sWs","row":"Table_row__3AK9w","col":"Table_col__33FWB"};